import React from 'react';
import styled from 'styled-components';
import { formatMsisdn } from '../utils/helpers';

interface Props {
	backgroundColor: string;
	largeText?: boolean;
	title: string;
	name: string;
	values: any[];
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SelectContainer = styled.div<{ backgroundColor: string; largeText?: boolean }>`
	position: relative;
	height: 100%;
	select {
		width: 100%;
		height: 100%;
		border: 1px solid #969696;
		padding-left: 0.5em;
		${(props) => (props.largeText ? 'font-size: 1.6em;' : '')}
		background-color: ${(props) => props.backgroundColor};
	}
	.input-wrapper{
		height: 100%;
		position: relative;
	}
	.text-wrapper {
		margin-top: -13px;
		margin-left: 5px;
		position: absolute;
		top: 0;
		left: 0;
		span{
			color: #969696;
			background-color: ${(props) => props.backgroundColor};
			padding: 0 0.4em 0 0.4em;
			height: 1em;
		}
	}
`;

export const StyledDropdown: React.FC<Props> = (props: Props) => (
	<SelectContainer backgroundColor={props.backgroundColor} largeText={props.largeText}>
		<div className={'input-wrapper'}>
			<div className={'text-wrapper'}>
				<span>{props.title}</span>
			</div>
			<select name={props.name} onChange={props.onChange}>
				{props.values.map((value: any, key: number) => (
					<option key={key} value={value.mdisdn}>
						{formatMsisdn(value.msisdn)}
					</option>
				))}
			</select>
		</div>
	</SelectContainer>
);
